import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import createRootReducer from './reducers';
import activityLoggerMiddleware from './middleware/activityLoggerMiddleware';
import adobeLaunchMiddleware from './middleware/adobeLaunchMiddleware';
import memberDetailsIoResponseMiddleware from './middleware/memberDetailsIoResponseMiddleware';

export const history = createBrowserHistory();

export default function configureStore(preloadedState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  let middlewares = [
    routerMiddleware(history),
    thunk,
    memberDetailsIoResponseMiddleware,
  ]
  if (process.env.REACT_APP_CARRIER_ID === 'nw') {
    middlewares = [
      ...middlewares,
      activityLoggerMiddleware,
    ]
  }
  if (process.env.REACT_APP_CARRIER_ID === 'as') {
    middlewares = [
      ...middlewares,
      adobeLaunchMiddleware,
    ]
  }
  if (process.env.NODE_ENV !== 'production'  && process.env.NODE_ENV !== 'uat') {
    middlewares = [
      ...middlewares,
      logger,
    ]
  }
  return createStore(
    createRootReducer(history),
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        ...middlewares,
      ),
    ),
  );
}
